// Rounds to at most `decimals` decimal places. Trailing zeros are dropped, so
// whole values stay whole ("37", not "37.0"), and floating-point accumulation
// artefacts such as 27.600000000000004 collapse to 27.6. Negative values round
// half away from zero's usual direction (Math.round breaks ties upwards), which
// is irrelevant at display precision.
export function roundToDecimals(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}
